import client from 'enrollment-platform/api/eps.client'
import {
  ContributionJobHistoryItem,
  GetLatestJobResponse,
} from '../types/types'

/**
 * Retrieves the latest contribution job for a customer
 * @param customerId
 * @returns
 */
export async function getLatestContributionJob(
  customerId: string
): Promise<GetLatestJobResponse> {
  const { data } = await client.get<GetLatestJobResponse>(
    `/customers/${customerId}/contributions/jobs`
  )
  return data
}

/**
 * Retrieves a list of all the contribution jobs for a customer
 * @param customerId
 * @returns
 */
export async function getContributionJobs(
  customerId: string
): Promise<ContributionJobHistoryItem[]> {
  const { data } = await client.get<ContributionJobHistoryItem[]>(
    `/customers/${customerId}/contributions/jobs/all`
  )
  return data
}

/**
 * Used to pool a tracked job. After checking if there's an active job with getClientModelSubmittedJobs,
 * this function is used to poll the job status directly with the job ID.
 * @param customerId
 * @param jobId
 * @returns
 */
export async function getContributionJobStatus(
  customerId: string,
  jobId: string
) {
  const { data } = await client.get<GetLatestJobResponse>(
    `/customers/${customerId}/contributions/${jobId}/status`
  )
  return data
}

/**
 * Applies a contribution model to a customer
 * @param customerId The customer ID
 * @param modelId
 * @param benchmarkId
 * @returns
 */
export async function postApplyContributionModel(
  customerId: string,
  modelId: number,
  benchmarkId?: string
): Promise<string | null> {
  let url = `/customers/${customerId}/contributions/${modelId}/persist`
  if (benchmarkId) {
    url = `${url}?benchmarkSnapshotId=${benchmarkId}`
  }
  const { data } = await client.post<{ jobId: string }>(url)

  return data.jobId
}
